/* unplugin-vue-components disabled */import { render } from "./TrainAnswerView.vue?vue&type=template&id=7c9d9a0e&scoped=true"
import script from "./TrainAnswerView.vue?vue&type=script&lang=js"
export * from "./TrainAnswerView.vue?vue&type=script&lang=js"

import "./TrainAnswerView.vue?vue&type=style&index=0&id=7c9d9a0e&lang=scss&scoped=true"
import "./TrainAnswerView.vue?vue&type=style&index=1&id=7c9d9a0e&lang=scss"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c9d9a0e"]])

export default __exports__